<div class="dialog-image">
  <img [src]="imagenes[indexSeleccionado]" alt="Imagen ampliada" />

  <span class="title-img">{{getImgTitle(imagenes[indexSeleccionado])}}</span>

  <button class="btn btn-danger mt-2 mb-2 btn-position" (click)="cerrarDialog()">
    <i class="fa-solid fa-circle-xmark"></i>
  </button>

  <div class="carrousel-btn">
    <button class="btn btn-primary" (click)="previous()" [disabled]="disabledPrevious()"><i class="fa-solid fa-circle-left"></i></button>
    <button class="btn btn-primary" (click)="next()" [disabled]="!disabledNext()"><i class="fa-solid fa-circle-arrow-right"></i></button>
  </div>
</div>